<template>
  <section class="subscription" id="pricing">
    <div class="my-3 px-3">
      <router-link to="/" class="ef-logo-text text-dark">
        <img src="@/assets/EliteFitAI-Logo.svg" alt="EliteFit Logo" class="ef-logo"> ELITEFIT.AI
      </router-link>
    </div>
    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="title-box text-center">
          <h1 class="title-heading font-weight-bold mt-4">Choose Your EliteFit.AI Plan.</h1>
          <p class="text-muted f-17 mt-3">What Does You Need?</p>
        </div>
      </div>
    </div>
    <div class="pricing-outer-container">
      <div class="pricing-tabs-container">
        <div class="pricing-tabs">
          <div v-for="tab of tabs"
               @click="selectedTab = tab"
               class="pricing-tab text-capitalize"
               :class="{'selected': selectedTab === tab}">{{ tab }}</div>
        </div>
      </div>
      <div class="pricing-grid">
        <div v-for="plan of selectedTabPlans" class="pricing-card">
          <div class="pricing-card-about">
            <div class="product-image">
              <img :src="plan.image"/>
            </div>
            <div class="product-title">{{ plan.name }}</div>
            <div class="price-and-button">
              <div class="price-container">
                <div class="d-flex align-items-center">
                  <span class="currency-amount">{{`${plan.country.iso}${plan.country.currencySymbol}${plan.amount}`}}</span>
                  <span class="valid-duration">every<br>{{ plan.validityType === 'yearly' ? 'year':'month' }}</span>
                </div>
              </div>
              <b-button class="accept-plan-button" @click="acceptPlan(plan)">{{plan.acceptPlanButtonText}}</b-button>
            </div>
          </div>
          <div class="pricing-card-features">
            <span class="features-heading">This includes:</span>
            <div class="features-content">
              <div v-for="feature of plan.features" class="feature-item">
                <div class="icon-style">
                  <b-icon class="status-icon" icon="check-circle-fill"></b-icon>
                </div>
                <span class="text-style">{{feature}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader v-if="loading"></loader>
  </section>
</template>
<script>
import b2bService from "@/module_user/api/b2b-service";

export default {
  data() {
    return {
      loading: false,
      plans: [],
      tabs: [],
      selectedTab: ''
    }
  },
  computed: {
    selectedTabPlans() {
      return this.plans.filter(plan => plan.validityType === this.selectedTab);
    }
  },
  methods: {
    acceptPlan(plan) {
      const {id: planId, country} = plan;
      this.loading = true;
      b2bService.createEndUserCheckoutSession({
        planId, countryIso: country.iso
      }).then(data => {
        window.location.href = data.url;
      }).catch(error => {
        this.$swal({
          icon: 'error',
          title: 'Payment Processing Failed',
          text: 'Sorry, your payment could not be processed. Please try again later.',
          confirmButtonColor: '#73bc44',
          confirmButtonText: 'OK'
        });
      }).finally(_ => this.loading = false);
    }
  },
  async mounted() {
    this.loading = true;
    this.plans = await b2bService.endUserSubscriptionPlans("Fitness Program")
    this.plans.forEach(plan => {
      if (!this.tabs.includes(plan.validityType)) this.tabs.push(plan.validityType);
    });
    this.selectedTab = this.tabs[0];
    this.loading = false;
  }
}
</script>
<style lang="scss" scoped>
.pricing-outer-container {
  height: 100%;
  width: 100%;
  opacity: 1;
  padding: 4px;
  transition: opacity .2s linear;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;

  .pricing-tabs-container {
    position: relative;
    margin-bottom: 24px;

    .pricing-tabs {
      display: flex;
      border-radius: 22px;
      border: 4px solid #d7d7d7;
      background-color: #d7d7d7;

      .pricing-tab {
        border-radius: 22px;
        background-color: transparent;
        font-size: 14px;
        font-weight: 400;
        height: auto;
        line-height: 20px;
        padding: 8px 32px;
        transition: color .15s ease-in, font-weight .15s ease-in;
        cursor: pointer;
        display: flex;
        position: relative;
        text-align: left;
        align-items: center;
      }
      .pricing-tab.selected {
        background-color: #7faf3c;
        color: white;
        font-weight: 500;
      }
    }
  }
  .pricing-grid {
    display: grid;
    grid-gap: 8px;
    grid-template-columns: repeat(auto-fit, 412px);
    justify-content: center;
    width: 100%;

    .pricing-card {
      border-radius: 14px;
      padding: 34px 36px 26px;
      width: 312px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      background-color: #ededed;

      .pricing-card-about {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        flex-wrap: nowrap;

        .product-image {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          height: 120px;
          width: 100%;

          img {
            border-radius: 6px;
            margin-bottom: 16px;
            max-height: 120px;
            max-width: 100%;
          }
        }
        .product-title {
          width: 100%;
          margin-bottom: 12px;
          font-size: 20px;
        }
        .price-and-button {
          display: flex;
          flex-direction: column;
          justify-content: end;
          width: 100%;

          .price-container {
            height: 42px;
            display: flex;
            align-items: flex-start;
            margin: -2px;
            flex-direction: column;

            .currency-amount {
              margin-right: 4px;
              font-weight: 700;
              font-size: 36px;
            }
            .valid-duration {
              opacity: .5;
              font-size: 13px;
            }
          }
          .accept-plan-button {
            background-color: rgb(127, 175, 60);
            border-color: rgb(127, 175, 60);
            color: #ffffff;
            border-radius: 22px;
            height: 44px;
            margin-top: 16px;
            position: relative;
          }
        }
      }
      .pricing-card-features {
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        color: #1a1a1a99;

        .features-heading {
          margin: 12px 0;
          font-size: 14px;
        }
        .features-content {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;

          .feature-item {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: nowrap;

            .icon-style {
              margin-top: 2px;
              display: flex;
              flex-wrap: nowrap;
              min-width: 28px;
              .status-icon {
                height: 16px;
                margin-right: 12px;
                color: rgba(14 19 25 / 44%);
                padding: 0;
              }
            }
            .text-style {
              line-height: 1.2;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>